// extracted by mini-css-extract-plugin
export default {"wrap":"xB-z","logoContainer":"yB-z","brandImg":"zB-z","logoImg":"AB-z","logoButton":"BB-z"};